/* eslint-disable */
// Base value ranges for different chocobo tiers
const CHOCOBO_BASE_VALUES = {
    TIER_1: { min: 1000, max: 5000 },    // Level 1-10
    TIER_2: { min: 5000, max: 15000 },   // Level 11-20
    TIER_3: { min: 15000, max: 30000 },  // Level 21-30
    TIER_4: { min: 30000, max: 60000 }   // Level 31-40
  }
  
  // Multipliers for special attributes
  const ATTRIBUTE_MULTIPLIERS = {
    SPEED_XFACTOR: 1.5,
    STAMINA_XFACTOR: 1.5,
    GOOD_BEHAVIOR: 1.3,    // For behaviors 1-3
    BAD_BEHAVIOR: 0.7,     // For behaviors 6-8
    RARE_COLOR: 1.4        // For gold, black chocobos
  }
  
  export class AuctionManager {
    static calculateBaseValue(chocobo) {
      // Determine tier based on level
      let tier
      if (chocobo.level <= 10) tier = 'TIER_1'
      else if (chocobo.level <= 20) tier = 'TIER_2'
      else if (chocobo.level <= 30) tier = 'TIER_3'
      else tier = 'TIER_4'
  
      const { min, max } = CHOCOBO_BASE_VALUES[tier]
      const levelProgress = (chocobo.level % 10) / 10
      
      // Base value within tier range based on level progress
      let baseValue = min + (max - min) * levelProgress
  
      // Adjust for stats relative to level
      const expectedStats = chocobo.level * 2  // Simple approximation
      const statsDifference = (chocobo.speed + chocobo.stamina) / expectedStats
      baseValue *= Math.max(0.8, Math.min(1.5, statsDifference))
  
      return Math.round(baseValue)
    }
  
    static calculateOwnerInterest(owner, chocobo, ownerChocobos) {
      let interest = 1.0
  
      // Competitive owners interested in strong rivals
      if (owner.competitiveness > 70) {
        const ownerBestChocobo = ownerChocobos && ownerChocobos.length > 0 
          ? ownerChocobos.reduce((best, current) => 
              (current.level > best.level) ? current : best
            , ownerChocobos[0])
          : null;
        
        if (ownerBestChocobo) {
          const levelDiff = chocobo.level - ownerBestChocobo.level
          
          if (levelDiff > 0) {
            // High interest in chocobos better than their best
            interest *= 1 + (owner.competitiveness / 100) * (levelDiff / 10)
          } else if (levelDiff > -5) {
            // Still interested in close competitors
            interest *= 1 + (owner.competitiveness / 150)
          }
        } else {
          // If no chocobos, high interest in any chocobo
          interest *= 1.2
        }
      }
  
      // Ambitious owners more interested in potential
      if (owner.ambition > 60) {
        const potentialModifier = (owner.ambition / 100) * 
          ((chocobo.hasSpeedXFactor || chocobo.hasStaminaXFactor) ? 1.3 : 1.0)
        interest *= potentialModifier
      }
  
      // Shrewd owners careful with money
      if (owner.shrewdness > 50) {
        const shrewdnessDiscount = 1 - ((owner.shrewdness - 50) / 100)
        interest *= shrewdnessDiscount
      }
  
      return interest
    }
  
    static generateBids(chocobo, owners, gameStore) {
      
      const baseValue = this.calculateBaseValue(chocobo)
      const bids = []
  
      // Filter out player and sort owners by their potential interest
      const potentialBidders = owners
        .filter(owner => !owner.isPlayer && owner.money >= baseValue * 0.8)
        .map(owner => {
          const ownerChocobos = gameStore.getChocobosByOwnerId(owner.id) || []
          const interest = this.calculateOwnerInterest(owner, chocobo, ownerChocobos)
          return { owner, interest }
        })
        .sort((a, b) => b.interest - a.interest)
        .slice(0, 5) // Take only top 5 most interested owners
  
      potentialBidders.forEach(({ owner, interest }) => {
        const bidAmount = Math.round(baseValue * interest)
        
        // Add some randomization to final bid (±10%)
        const randomFactor = 0.9 + (Math.random() * 0.2)
        const finalBid = Math.round(bidAmount * randomFactor)
        
        if (finalBid <= owner.money) {
          bids.push({
            ownerId: owner.id,
            amount: finalBid
          })
        }
      })
  
      return bids.sort((a, b) => b.amount - a.amount)
    }      
  
    static handleSale(chocobo, buyer, seller, amount, gameStore) {
      // CRITICAL: Prevent any sale involving player chocobos
      if (seller.isPlayer || buyer.isPlayer) {
        console.error('BLOCKED: Attempted sale involving player owner', {
          chocobo: chocobo.name,
          seller: seller.name,
          buyer: buyer.name,
          sellerIsPlayer: seller.isPlayer,
          buyerIsPlayer: buyer.isPlayer
        })
        return {
          success: false,
          error: 'Player transactions not allowed through this method'
        }
      }

      // Transfer money
      buyer.money -= amount
      seller.money += amount
  
      // Transfer ownership
      const sellerIndex = seller.chocoboIds.indexOf(chocobo.id)
      if (sellerIndex > -1) {
        seller.chocoboIds.splice(sellerIndex, 1)
      }
      buyer.chocoboIds.push(chocobo.id)
  
      return {
        success: true,
        newOwner: buyer,
        amount: amount
      }
    }
  }